import { Stack, List, ListItem, StackProps } from '@mui/material';
import { MCTypography } from 'components/MyCustomers/MyCustomersTypography';
import { Product } from 'generated/graphql';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { ReactNode } from 'react';

type BundledProductsProps = {
    product: Product;
    stackProps?: StackProps;
    optionsButton?: ReactNode;
};

export function BundledProducts({ product, stackProps, optionsButton }: BundledProductsProps) {
    const { t } = useServerTranslation();
    if (!product.bundledProducts?.length) {
        if (!product.consultantUserId) {
            return null;
        }

        return (
            <Stack {...stackProps}>
                <Stack direction="row" justifyContent="space-between">
                    <MCTypography variant="subtitle1">
                        {t('my-customers.products.bundle-products-included')}
                    </MCTypography>
                    {optionsButton}
                </Stack>
                <List>
                    <ListItem>
                        <MCTypography variant="body1">
                            {t('my-customers.products.no-bundle-products')}
                        </MCTypography>
                    </ListItem>
                </List>
            </Stack>
        );
    }

    return (
        <Stack {...stackProps}>
            <Stack direction="row" justifyContent="space-between">
                <MCTypography variant="subtitle1">
                    {t('my-customers.products.bundle-products-included')}
                </MCTypography>
                {optionsButton}
            </Stack>
            <List>
                {product.bundledProducts?.map((bundleProduct, index) => (
                    <ListItem key={index} sx={{ display: 'flex', justifyContent: 'space-between' }} divider>
                        <MCTypography component="div" variant="body1">
                            {bundleProduct.name}
                        </MCTypography>
                        <MCTypography component="div" variant="body1" paddingRight={0.5}>
                            {t('product.quantity', { quantity: bundleProduct.quantity })}
                        </MCTypography>
                    </ListItem>
                ))}
            </List>
        </Stack>
    );
}
